import { put, takeLatest } from 'redux-saga/effects';
import urls from 'utils/config';
import { networkErrorHandler } from 'utils/errrorHandlers';
import request from 'utils/request';
import {
  fetchInterswitchConfig,
  fetchNabrollConfig,
  fetchPaymentConfigFailure,
  fetchPaymentConfigSuccess,
  fetchPayproKanoConfig,
  fetchPaystackConfig,
  fetchPayUnimaidConfig,
  fetchRemitaConfig,
  fetchSokotoIrsConfig,
} from '../actions';
import paymentConfigTypes from '../types';

const { API_BASE_URL } = urls || {};

function* fetchAllPaymentConfig() {
  const url = `${API_BASE_URL}/paylog-configurations`;

  const response = yield request({
    method: 'get',
    url,
  });

  console.log({ response });

  if (response.success) {
    const remita = [];
    const paystack = [];
    const interswitch = [];
    const nabroll = [];
    const payproKano = [];
    const sokotoIrs = [];
    let payUnimaid = '';
    if (response.raw.length > 0) {
      response.raw.forEach((config) => {
        if (config.paymentPlatform === 'REMITA') {
          remita.push(config.id);
        } else if (config.paymentPlatform === 'PAYSTACK') {
          paystack.push(config.id);
        } else if (config.paymentPlatform === 'INTERSWITCH') {
          interswitch.push(config.id);
        } else if (config.paymentPlatform === 'NABROLL') {
          nabroll.push(config.id);
        } else if (config.paymentPlatform === 'PAYPRO_KANO') {
          payproKano.push(config.id);
        } else if (config.paymentPlatform === 'PAYUNIMAID') {
          // TODO: this will be change to the paylog unimaid payment platform
          payUnimaid = config.id;
        } else if (config.paymentPlatform === 'SOKOTO_IRS') {
          sokotoIrs.push(config.id);
        }
      });
      if (remita) {
        yield put(fetchRemitaConfig(remita));
      }
      if (paystack) {
        yield put(fetchPaystackConfig(paystack));
      }
      if (interswitch) {
        yield put(fetchInterswitchConfig(interswitch));
      }
      if (sokotoIrs.length > 0) {
        yield put(fetchSokotoIrsConfig(sokotoIrs));
      }
    }
    if (nabroll) {
      yield put(fetchNabrollConfig(nabroll));
    }
    if (payproKano) {
      yield put(fetchPayproKanoConfig(payproKano));
    }
    if (payUnimaid) {
      yield put(fetchPayUnimaidConfig(payUnimaid));
    }
    yield put(fetchPaymentConfigSuccess(response.raw));
  } else {
    yield put(
      fetchPaymentConfigFailure(
        'An error occured. Please reload the page to try again.'
      )
    );
    networkErrorHandler(response?.statusCode, response?.message);
  }
}

export function* getAllPaymentConfig() {
  yield takeLatest(
    paymentConfigTypes.FETCH_PAYMENT_CONFIG_REQUEST,
    fetchAllPaymentConfig
  );
}
